import { useMemo } from 'react';
import { useSellerConversations } from './queries/sellerQueries';

export const useConversationUnread = (enabled = true) => {
  const { data: conversations = [], refetch, isFetching } = useSellerConversations(enabled);

  const unreadCount = useMemo(
    () =>
      conversations.reduce(
        (sum: number, c: { unreadBySeller?: number }) => sum + (c.unreadBySeller || 0),
        0
      ),
    [conversations]
  );

  return { unreadCount, refreshUnread: refetch, isFetching };
};

export default useConversationUnread;
